import axios from 'axios';

const API_BASE = (window.ENV?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL) + '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const contactAPI = {
  submit: async (data) => {
    try {
      const response = await api.post('/contact', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getAll: async () => {
    try {
      const response = await api.get('/contact');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export const chatAPI = {
  sendMessage: async (data) => {
    try {
      const response = await api.post('/chat', data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getMessages: async (sessionId) => {
    try {
      const response = await api.get(`/chat/${sessionId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getAllSessions: async () => {
    try {
      const response = await api.get('/chat');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default api;
